import { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import PurchasedContentScreen from '../components/PurchasedContentScreen'

const PurchasedContentRoute: FC<RouteComponentProps> = props => <PurchasedContentScreen {...props} />

export default WithContainerRoute(PurchasedContentRoute)
